import axios from 'axios';
import { API, authHeaders } from './client';

export const getProductsAdmin = (token) =>
  axios.get(`${API}/products/admin`, authHeaders(token)).then(r => r.data);

export const createProduct = (token, data) =>
  axios.post(`${API}/products`, data, authHeaders(token)).then(r => r.data);

export const updateProduct = (token, id, data) =>
  axios.put(`${API}/products/${id}`, data, authHeaders(token)).then(r => r.data);

export const deleteProduct = (token, id) =>
  axios.delete(`${API}/products/${id}`, authHeaders(token)).then(r => r.data);

export const toggleSale = (token, id) =>
  axios.put(`${API}/products/${id}/toggle-sale`, {}, authHeaders(token)).then(r => r.data);

export const toggleVisibility = (token, id) =>
  axios.put(`${API}/products/${id}/toggle-visibility`, {}, authHeaders(token)).then(r => r.data);

export const uploadImage = (token, file) => {
  const form = new FormData();
  form.append('file', file);
  return axios.post(`${API}/upload/image`, form, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

export const uploadPdf = (token, file) => {
  const form = new FormData();
  form.append('file', file);
  return axios.post(`${API}/upload/pdf`, form, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};
